module.exports = __webpack_public_path__ + "static/img/12.ae6d5bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/honour/12.png
// module id = yWOL
// module chunks = 1